module.exports = __webpack_public_path__ + "df50acdfbfda704e257a5719b5842408.pdf";